/* eslint-disable */
import React, { useEffect, FC, Fragment, useRef, memo } from 'react';
//Styles and animations//
import SuccessPageComponent from '../../components/successPage';
import injectSheet from 'react-jss';
import classNames from 'classnames';
import styleSheet from './styles';
//Utils//
import { isIe11 } from 'Utils/browserDetect';
import { ITourInterface } from '@store/tour/types';

interface Props {
  classes?: any;
  completed?: boolean;
  success_title?: string;
  success_subtitle?: string;
  success_description?: string;
  tour: ITourInterface;
  stepInputState: object;
}

const SuccessPage: FC<Props> = ({
  classes,
  completed,
  success_title,
  success_subtitle,
  success_description,
  tour,
  stepInputState,
}: Props) => {
  if (!tour.mode) {
    // Post message to parent iframe to close on completion
    if (tour.isStandalone || tour.isHover === '1') {
      const closeData = JSON.stringify({
        // below passes all form data //
        // ...stepInputState,
        isComplete: completed,
        inquiry: stepInputState['inquiry'],
      });
      // pass data to SS and close iframe //
      setTimeout(() => {
        window.parent.postMessage(
          `data:::closeHoverWithData:::${closeData}`,
          '*'
        );
      }, 1000);
    } else {
      window.parent.postMessage(
        { message: 'RegistrationForm_Completed', millisecondsUntilClose: 4000 },
        '*'
      );
    }
  }

  const [passedInTitle, setPassedInTitle] = React.useState(null);
  const [passedInSubTitle, setPassedInSubTitle] = React.useState(null);
  const [passedInDescription, setPassedInDescription] = React.useState(null);

  const checkForMessage = (event: any) => {
    if (event.data.message === 'successCopy' && event.data.successData) {
      setPassedInTitle(event.data.successData.title);
      setPassedInSubTitle(event.data.successData.subtitle);
      setPassedInDescription(event.data.successData.description);
    }
  };

  React.useEffect(() => {
    window.addEventListener('message', checkForMessage);
    return () => {
      window.removeEventListener('message', checkForMessage);
    };
  }, []);

  // Show success page
  return (
    <div className={classes.centerForm}>
      <div
        className={classNames({
          [classes.centerForIE]: isIe11(),
        })}
      >
        <SuccessPageComponent
          successTitle={passedInTitle || success_title}
          successSubtitle={passedInSubTitle || success_subtitle}
          successDescription={passedInDescription || success_description}
        />
      </div>
    </div>
  );
};

export default injectSheet(styleSheet)(SuccessPage);
